import PropTypes from "prop-types";
import { useState } from "react";

import { usePlacesWidget } from "react-google-autocomplete";
import { TextField, Box, InputAdornment, Icon } from "@mui/material";
import AppConfig from "../../../../appConfig";

function GoogleAddressField({ displayName, fieldRef, isOptional, options }) {
  const [googleAddressFormatted, setGoogleAddressFormatted] = useState(null);
  const [googleAddressLatitude, setGoogleAddressLatitude] = useState(null);
  const [googleAddressLongitude, setGoogleAddressLongitude] = useState(null);
  const [googleAddressObject, setGoogleAddressObject] = useState(null);

  const { ref } = usePlacesWidget({
    apiKey: AppConfig.google_map_key, // "AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0",
    onPlaceSelected: (place) => {
      // console.log(place);
      setGoogleAddressFormatted(place.formatted_address);
      setGoogleAddressLatitude(place.geometry.location.lat());
      setGoogleAddressLongitude(place.geometry.location.lng());
      setGoogleAddressObject(
        JSON.stringify({
          formatted_address: place.formatted_address,
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        })
      );
    },
    options: {
      // types: ["(regions)"],
      types: ["address"],
      // componentRestrictions: { country: "ng" },
    },
  });

  // console.log(options);
  return (
    <Box>
      {/* <Label>{displayName}</Label>
      <Autocomplete
        apiKey="AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0"
        onPlaceSelected={(place) => {
          console.log(place);
          setGoogleAddress(place);
        }}
      /> */}
      <TextField
        // ref={ref}
        inputRef={ref}
        margin="dense"
        label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        multiline
        minRows={2}
        options={options}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>place</Icon>
            </InputAdornment>
          ),
        }}
      />
      {/* <input
        type="hidden"
        name={`${fieldRef}[formatted_address]`}
        value={googleAddressFormatted}
      />
      <input
        type="hidden"
        name={`${fieldRef}[latitude]`}
        value={googleAddressLatitude}
      />
      <input
        type="hidden"
        name={`${fieldRef}[longitude]`}
        value={googleAddressLongitude}
      /> */}
      <input
        id={`dff_${fieldRef}`}
        type="hidden"
        name={`${fieldRef}`}
        value={googleAddressObject}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
GoogleAddressField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

GoogleAddressField.defaultProps = {
  options: null,
};

export default GoogleAddressField;
